import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  root: {
    flexGrow: 1,
    textAlign:'center',
  },
  text:{
    fontSize: 20,
    textAlign: 'center',
    color:'#444444'
  },
  button:{
    textAlign: 'center'
  }
})

  class Intro extends Component{
    render(){
      const { classes } = this.props;
      return(
    <div className={classes.root}>
      <h1>ITスキル適正試験</h1>
      <h2 className={classes.text}>問題は100問+例題6問、制限時間は80分です。</h2>
      <h2 className={classes.text}>計算やメモ等は計算用紙を使用してください。</h2>
      <h2 className={classes.text}>電卓やスマートフォン等の使用は禁止です。</h2>
      <h2 className={classes.text}>制限時間内に終了しても構いません。</h2>
      <h2 className={classes.text}>試験中にリロード、ぺージを戻る、閉じるなどの行為を行なった場合、試験は終了となります。</h2>
      <h2 className={classes.text}>「START」をクリックして試験を始めてください。</h2>
    </div>

  )}
  }

  Intro.propTypes = {
    classes: PropTypes.object.isRequired
  };

  export default withStyles(styles, { withTheme: true })(Intro);



// WEBPACK FOOTER //
// ./src/components/quiz/Intro.js